import gql from 'graphql-tag';

const createBillMeExistingPerson = gql`
mutation createBillMeExistingPerson($input: BillMePersonInput) {
  createBillMeExistingPerson(input: $input) {
    personId
    firstName
    middleName
    lastName
    phoneNumber
    addressLine1
    addressLine2
    city
    state
    zipCode
    country
    spouseId
  }
}
`;

export default createBillMeExistingPerson;



// WEBPACK FOOTER //
// ./src/app/mutations/createBillMeExistingPerson.js